import React from 'react'
import Uploader from './../components/uploader'

class MediaLibrary extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			items: this.props.media_library || []
		}
	}

	handleImageUploadComplete(imageURL){
		// Add the image to the items list.
		const items = this.state.items

		// Generate a new id.
		const id = items.reduce( (id, item) => {
			if(item.id >= id){
				id = parseInt(item.id, 10) + 1
			}
			return id
		}, 0)

		// Add the new item to the list.
		items.push({
			id: id,
			imageURL: imageURL
		})

		// Save it to state.
		this.setState({items})

		// Notify the parent.
		this.props.handleMediaUpdate && this.props.handleMediaUpdate()
	}

	handleItemRemove(id){
		// Filter the list by the item selected to remove.
		// eslint-disable-next-line
		const items = this.state.items.filter( item => item.id != id )

		// Save the updated array to state.
		this.setState({ 
			items: items,
		}, () => {
			// Notify the parent.
			this.props.handleMediaUpdate && this.props.handleMediaUpdate()
		})
	}

	render() {
		return (
			<section className="media_library">
				<h3>Media Library</h3>
				<div className="grid">
					{this.state.items.map( (item) => { 
						return (
							<div key={item.id} data-id={item.id} className="media_container">
								<img src={decodeURIComponent(item.imageURL)} data-src={decodeURIComponent(item.imageURL)} alt={item.id} />
								<button className="delete" onClick={ (e) => {this.handleItemRemove(item.id)} }>Delete</button>
							</div>
						)
					})}
				</div>
				<Uploader 
					className="media_drop" 
					uploadComplete={ (imageURL) => this.handleImageUploadComplete(imageURL) } 
					label="Drop (or click) to upload an image"
				/>
			</section>
		)
	}
}

export default MediaLibrary



// WEBPACK FOOTER //
// ./src/components/media_library.js